import Splide from '@splidejs/splide';

let logoSlides = document.getElementsByClassName('logo-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < logoSlides.length; i++) {

        let splide = new Splide(logoSlides[i], {
            type: 'loop',
            autoplay: true,
            pauseOnHover: 'true',
            interval: 2500,
            perPage: 5,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: false,
            width: '100%',
            breakpoints: {
                1024: {
                    gap: 12,
                    perPage: 4,
                },
                640: {
                    perPage: 2,
                    width: '90%',
                },
            },
        });

        splide.mount();
    }
});
